import { Component, OnInit, ViewChild } from '@angular/core'
import { Timestamp } from '@engineering11/types'
import { E11ModalComponent } from '@engineering11/ui-lib/e11-modal'
import { Store } from '@ngrx/store'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { ICnectUser } from '../../model/interfaces'
import { sharedSelectors, userActions } from '../../store/index'

@Component({
  selector: 'account-manage-profile-photo',
  templateUrl: './manage-profile-photo.component.html',
  styleUrls: ['./manage-profile-photo.component.scss'],
})
export class AccountManageProfilePhotoComponent implements OnInit {
  @ViewChild('modalProfilePic')
  modalProfilePic!: E11ModalComponent

  user?: Timestamp<ICnectUser> | null
  destroy$: Subject<boolean> = new Subject<boolean>()

  constructor(private store: Store) {}
  ngOnInit(): void {
    this.store
      .select(sharedSelectors.getCurrentUser)
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => (this.user = user))
  }

  saveNewPhoto(newPhotoUrl: string) {
    this.store.dispatch(userActions.UpdateUserPhoto({ id: this.user!.id, photoURL: newPhotoUrl }))
    this.modalProfilePic.close()
  }

  removeProfilePhoto() {
    this.store.dispatch(userActions.UpdateUserPhoto({ id: this.user!.id, photoURL: null }))
    this.modalProfilePic.close()
  }
}
